import fetch from "auth/FetchInterceptor";

const BannerService = {};

BannerService.getBanner = function (params) {
  const { banner_id, languageId } = params;

  return fetch({
    url: `/banners?banner_id=${banner_id}`, // Adjust the endpoint as needed
    method: "GET",
    headers: {
      "Language-Id": 1,
    },
  });
};

BannerService.getBannerById = function (bannerId) {
  return fetch({
    url: `/banners/${bannerId}/`, // Adjust the endpoint as needed
    method: "GET",
  });
};

BannerService.createBanner = function ({ params, headers }) {
  console.log(params, headers);

  return fetch({
    url: `/banners/`,
    method: "POST",
    data: params,
    headers: headers,
  });
};

BannerService.updateBanner = function ({ params, bannerId }) {
  return fetch({
    url: `/banners/${bannerId}/`,
    method: "PUT",
    data: params,
  });
};

BannerService.setBanner = function (data) {
  return fetch({
    url: "/Banners",
    method: "Banner",
    data: data,
  });
};

// New method for deleting a banner
BannerService.deleteBanner = function (bannerId) {
  return fetch({
    url: `/banners/${bannerId}/`, // Adjust the endpoint as needed
    method: "delete",
  });
};

export default BannerService;
